import React from 'react';

import { FlexLayout } from '@swyftx/aviary/atoms/Layout/Flex';
import { Heading, Body } from '@swyftx/aviary/atoms/Typography';
import { useTailwindBreakpoint } from '@swyftx/aviary/hooks/useTailwindBreakpoint';

interface LoansSectionProps {
  header: {
    title: string;
    description: string;
  };
  content: React.ReactNode;
  footer?: JSX.Element;
  button?: JSX.Element;
  buttonHeading?: JSX.Element; // New prop for optional heading above the button
}

const LoansSection: React.FC<LoansSectionProps> = ({ header, content, button, buttonHeading, footer }) => {
  const isXs = useTailwindBreakpoint('xs');

  return (
    <FlexLayout alignItems='center' direction='column' spacing={24}>
      {/* Heading */}
      <FlexLayout className='flex-col text-center' spacing={12}>
        <Heading size={isXs ? 'h3' : 'h2'} color='primary' weight='light'>
          {header.title}
        </Heading>
        <Body size='medium' color='secondary' weight='none'>
          {header.description}
        </Body>
      </FlexLayout>

      {/* Content */}
      <FlexLayout className='w-full'>{content}</FlexLayout>

      {/* Button Section */}
      {buttonHeading && button && (
        <FlexLayout className='flex-col text-center' spacing={12}>
          {buttonHeading}
          {button}
        </FlexLayout>
      )}
      {button && !buttonHeading && <FlexLayout className='mt-4'>{button}</FlexLayout>}

      {/* Optional Footer */}
      {footer && (
        <FlexLayout className='text-center' spacing={12}>
          {footer}
        </FlexLayout>
      )}
    </FlexLayout>
  );
};
LoansSection.displayName = 'LoansSection';

export { LoansSection };
